/* tslint:disable */
/* eslint-disable */
/**
 * AusgabeAutomatConnector
 * Connector für Ausgabeautomat zu ORSY Gateway und BDS Gateway.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CostCenter
 */
export interface CostCenter {
    /**
     * 
     * @type {string}
     * @memberof CostCenter
     */
    costCenterId: string;
    /**
     * 
     * @type {string}
     * @memberof CostCenter
     */
    costCenterName: string;
}

/**
 * Check if a given object implements the CostCenter interface.
 */
export function instanceOfCostCenter(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "costCenterId" in value;
    isInstance = isInstance && "costCenterName" in value;

    return isInstance;
}

export function CostCenterFromJSON(json: any): CostCenter {
    return CostCenterFromJSONTyped(json, false);
}

export function CostCenterFromJSONTyped(json: any, ignoreDiscriminator: boolean): CostCenter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'costCenterId': json['costCenterId'],
        'costCenterName': json['costCenterName'],
    };
}

export function CostCenterToJSON(value?: CostCenter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'costCenterId': value.costCenterId,
        'costCenterName': value.costCenterName,
    };
}

